export default {
    TOP: 'top',
    BOTTOM: 'bottom',
    START: 'start',
    END: 'end',
}